export default __webpack_public_path__ + "static/media/description-icon.d628f589.svg";